export { default as FloatingMenu } from './FloatingMenu'
